import connectToChain from "./connectToChain";
import connectToContracts from "./connectToContracts";
import extractTimeRemaining from "./extract-time-remaining";

const connect = async (address) => {
    const [signer, signerAddress] = await connectToChain(address);

    const [
        tokenContract,
        stakingContractNewStake,
        stakingContractNewStakePrivate,
        stakingContract_selfMaturing,
        stakingContract_new,
        stakingContract_35,
        stakingContract,
        stakingContractSelfMaturingPrivate,
        stakingContractAdditional,
    ] = await connectToContracts(signer);

    const timeRemaining = await extractTimeRemaining(stakingContract);
    const timeRemaining_35 = await extractTimeRemaining(stakingContract_35);
    const timeRemaining_new = await extractTimeRemaining(stakingContract_new);
    const private_stake_timeRemaining = await extractTimeRemaining(
        stakingContractSelfMaturingPrivate
    );
    const timeRemaining_newStake = await extractTimeRemaining(stakingContractNewStake);
    const timeRemaining_additional = await extractTimeRemaining(stakingContractAdditional);
    const timeRemaining_new_stakePrivate = await extractTimeRemaining(stakingContractNewStakePrivate);
    return {
        signerAddress,
        tokenContract,
        stakingContractNewStake,
        timeRemaining_newStake,
        stakingContractNewStakePrivate,
        timeRemaining_new_stakePrivate,
        stakingContract_selfMaturing,
        stakingContract_new,
        timeRemaining_new,
        stakingContract_35,
        timeRemaining_35,
        stakingContract,
        timeRemaining,
        private_stake: stakingContractSelfMaturingPrivate,
        private_stake_timeRemaining,
        stakingContractAdditional,
        timeRemaining_additional,
    };
};

export default connect;
